module.exports = __webpack_public_path__ + "static/media/carQuestion.c7ca3d78.png";